import { ref, onMounted } from 'vue'

export function useFilterOptions() {
    const filterOptions = ref({
        printers: [],
        inks: []
    })
    const loading = ref(false)
    const error = ref(null)

    const fetchFilterOptions = async () => {
        loading.value = true
        error.value = null
        
        try {
            const response = await fetch('/wp-json/dealers/v1/filter-options')
            
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`)
            }
            
            const data = await response.json()
            
            // Check if there's an error in the response
            if (data.error) {
                throw new Error(data.error)
            }
            
            filterOptions.value = {
                printers: data.printers || [],
                inks: data.inks || []
            }
            

            
        } catch (err) {
            console.error('Error fetching filter options:', err)
            error.value = err.message
            
            // Fallback to empty arrays if there's an error
            filterOptions.value = {
                printers: [],
                inks: []
            }
        } finally {
            loading.value = false
        }
    }

    // Auto-fetch on mount
    onMounted(() => {
        fetchFilterOptions()
    })

    return {
        filterOptions,
        loading,
        error,
        fetchFilterOptions
    }
}
